var React = require('react');

function Fire (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Artboard"),React.createElement("g",{"id":"Artboard","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("path",{"d":"M56.2768949,12 L73.7764278,51.4377831 C79.6031408,64.5691416 73.6815555,79.937695 60.550197,85.764408 C57.2282533,87.2384377 53.6342914,88 50,88 C36.0273725,88 24.7003199,76.6729474 24.7003199,62.7003199 C24.7003199,58.950255 25.5339801,55.2470878 27.1409742,51.8587908 L35.6481455,33.9216858 L35.6481455,33.9216858 L45.0030275,50 L56.2768949,12 Z","id":"Path-2","stroke":"#FEA7A7","strokeWidth":"5","fill":"#D32F2F"}))]);
}

Fire.defaultProps = {"width":"100px","height":"100px","viewBox":"0 0 100 100","version":"1.1"};

module.exports = Fire;

Fire.default = Fire;
